export enum Routes {
  Home = '/',
  Details = '/details',
  Review = '/review-service',
  ChangeAddress = '/addresses/change-address/',
  ChooseFavoriteAddress = '/addresses/choose-favorite',
  CreateAddress = '/addresses/new/',
  EditAddress = '/addresses/edit/:addressId',
  EditAddressNotes = '/order/edit/notes',
  EditAddressDoorbellPosition = '/order/edit/doorbell',
  SignUp = '/sign-up',
  SignIn = '/sign-in',
  ConfirmEmail = '/confirm-email',
  CompleteUserInfo = '/profile/edit',
  EditDeliveryTime = '/edit-delivery-time',
  ChooseDeliveryTime = '/choose-delivery-time',
  ChooseDeliveryTimeHelp = '/choose-delivery-time/help',
  ChooseDeliveryTimeHelpDetail = '/choose-delivery-time/help/:helpId',
  Profile = '/profile',
  OpeningHours = '/opening-hours',
  ConfirmationOpeningHours = '/confirm-opening-hours',
  Benefits = '/benefits',
  SelectPickUpPoint = '/select-pick-up-point',
  Addresses = '/addresses',
  Orders = '/orders',
  Cart = '/purchase/cart',
  PaymentMethod = '/purchase/payment-method',
  PaymentSuccess = '/purchase/success',
  ConfirmationFree = '/confirmation-free-purchase',
  PaymentError = '/purchase/error',
  RecoverPasswordInsertEmail = '/recover-password/submit-email',
  RecoverPasswordCheckEmail = '/recover-password/check-email',
  RecoverPasswordChangePassword = '/recover-password/change-password',
  ChangePassword = '/profile/change-password',
  ChangePasswordSuccess = '/profile/change-password/success',
  VerifyDelivery = '/details/verify-delivery',
  ChooseTransaction = '/orders/:orderId',
  TransactionDetails = '/orders/:orderId/:transactionId',
  OrderHelp = '/orders/help',
  Help = '/help/:mlkId',
  HelpSearchOrder = '/help/search-order',
  NewsList = '/news',
  NewsDetails = '/news/:newsId',
  TermsAndConditions = '/terms-and-conditions',
  PrivacyPolicy = '/privacy-policy',
  Services = '/services',
  /**
   * It's possible to find the feature ids as enum in general.models,
   * they are used to get the correct faq lists in page
   */
  Faq = '/faq/:feature',
  FaqDetails = '/faq/:feature/:faqId',
}
